export default __webpack_public_path__ + "static/media/person.c95073eb.svg";